// useReveal — return reveal variant + transition with reduced-motion guard.
//
// Plan ref: 06-01-PLAN-motion-primitives-view-transitions.md §Task 1
// Research: 06-RESEARCH-motion-responsive-a11y.md §11
// REQ:      UI-MOTION-04
//
// motion's useReducedMotion() reads (prefers-reduced-motion: reduce) at mount
// + listens for changes; we mirror its result by swapping the transition for
// a flat 80ms tween and disabling stagger.
//
// Components that author their own staggered list reveal SHOULD prefer this
// hook over hand-rolling the matchMedia branch.

import { useReducedMotion } from 'motion/react';
import { reveal, revealTransition, revealStagger, reducedMotionTransition } from './variants';

interface RevealHookResult {
  variants: typeof reveal;
  transition: typeof revealTransition | typeof reducedMotionTransition;
  stagger: typeof revealStagger | { staggerChildren: 0 };
}

export function useReveal(): RevealHookResult {
  const reduce = useReducedMotion();
  return {
    variants: reveal,
    transition: reduce ? reducedMotionTransition : revealTransition,
    stagger: reduce ? { staggerChildren: 0 } : revealStagger,
  };
}
